import * as React from 'react';
import * as ReactDOM from 'react-dom';
import * as cls from 'classnames';
import { Route, Link, withRouter } from 'react-router-dom';
import { Form, Errors, LocalForm, Control, actions, Field } from 'react-redux-form';
import * as CreDtos from "../../../CRE.dtos";

import TextFormGroup from "../../Controls/TextFormGroup";
import TextAreaFormGroup from "../../Controls/TextAreaFormGroup";
import ValidationMessage from "../../Controls/ValidationMessage";
import TextTagging from "../../Controls/TextTagging";
import * as Config from '../../../configuration/consts';
import { required, maxLength, minLength,numberRange, url} from "../../Validators/";
import {
  updateOn,
  validateOn,
  mapProps,
  showErrors
} from "../../Controls/ReactReduxFormSettings";

@withRouter
export class AddReply extends React.Component<any, any> {
    formDispatch;
    constructor(props) {
        super(props);

        this.state = { showDetail: true,linkType: "LINK", showAddPost: false }

        this.onToggleClicked = this.onToggleClicked.bind(this);

        this.onCancelClicked = this.onCancelClicked.bind(this);
        this.onLocalSubmit = this.onLocalSubmit.bind(this);
        this.onSubmit = this.onSubmit.bind(this);
        this.onTypeChange = this.onTypeChange.bind(this);
        this.onMemberTagged = this.onMemberTagged.bind(this);
    }

    onCancelClicked() {
        this.props.onCancelClicked();
    }
    onMemberTagged(comment, tags) {
        this.setState({selectedTags: tags});
        this.formDispatch(actions.load('post.comment', comment));
    }

    onToggleClicked() {
        this.setState({ showDetail: !this.state.showDetail });
    }


    onTypeChange(event) {
        this.setState({ linkType: event.target.value });
    }

    onLocalSubmit(form) {
        let post = new CreDtos.ForumPost();
        post = {...form};
        if(this.props.parentId){
            post.parentId = this.props.parentId;
        }
        if(this.props.currentUser.id){
            post.forumMemberId = this.props.currentUser.id;
        }
        if(this.props.activeFilter && this.props.activeFilter.id){
            let tag = new CreDtos.ForumTagSummary() ;
            tag.id = this.props.activeFilter.id;
            let tags: CreDtos.ForumTagSummary[] = [tag];
            post.tags = tags;
        }
        
        this.onSubmit(post);
    }

    async onSubmit(post) {

        if(post.files && post.files.length > 0){
            let file = post.files[0];
            let attachment = new CreDtos.ForumAttachment();
            attachment.fileName = file.name;
            attachment.fileType = file.type;
            attachment.data = await this.getEncodedFile(file);
            post.file = attachment;
        }

        this.props.savePost(this.props.forum.id, post, this.state.selectedTags);
        this.setState({ showDetail: false, linkType: "LINK", selectedTags: undefined });
        this.formDispatch(actions.reset('post'));
        this.formDispatch(actions.load('post.comment', undefined));
    }


    async getEncodedFile(file: File) {
        return new Promise<string>((resolve, reject) => {
            var reader = new FileReader();

            reader.onload = (event: any) => {
                var binaryString = reader.result;
                var encoded = btoa(binaryString);
                resolve(encoded);
            };
            reader.readAsBinaryString(file);
        });
    }
    
    render() {
        const { location, defaultSimpleMode, forum, ...props } = this.props;
        // If not defined assume full mode.
        let simpleMode = defaultSimpleMode ? defaultSimpleMode : false;

        let linkControl = this.state.linkType === Config.ATTACH_LINK ?
            <Control.text
                model=".link"
                id="post.link"
                type="url"
                component={TextFormGroup}
                placeholder="Link... (include http://)"
                validators={{
                    url: url
                }}
                updateOn={updateOn}
                validateOn={validateOn}
                mapProps={mapProps}
                maxLength={4095}
                controlProps={{
                    validate: true
                }}
                >
                <Errors
                    model=".link"
                    messages={{
                    url: "URL is not valid"
                    }}
                    show={showErrors}
                    component={ValidationMessage}
                />
                </Control.text> :
                <Control.file model=".files" className="form-control py-md-2" />;

            let postBox = <div className="discussion-board card lightgrey-bg mb-4">
                <div className="card-block row">
                    <div className="col-12 mb-1">
                        <TextTagging
                            model="post.comment"
                            onChange={this.onMemberTagged}
                            id="post.comment"
                            rows={3}
                            placeholder="Join the discussion..."
                            style={{width: "100%"}}
                            autoFocus={true}
                            tags={forum.members}
                            selectedTags={this.state.selectedTags}
                        >
                        </TextTagging>
                    </div>
                    <div className="col-12 col-md-4 mb-1 pr-md-1">
                        <select className="form-control" onChange={this.onTypeChange} value={this.state.linkType}>
                            <option value={Config.ATTACH_LINK}>Link</option>
                            <option value={Config.ATTACH_FILE}>File</option>
                        </select>
                    </div>
                    <div className="col-12 col-md-8 mb-1 pl-md-0">
                        {linkControl}
                    </div>
                    <div className="col-12">
                        <button  type="submit" className="btn btn-primary pull-right">Post</button>
                        <div className="btn btn-primary pull-right mx-2 clickable" onClick={this.onCancelClicked}>CANCEL</div>
                    </div>
                </div>
            </div>  ;
        let replyInput = simpleMode ?
            this.state.showDetail ?
                <div className="discussion-board input-group px-1 py-1">
                        <TextTagging
                            model="post.comment"
                            onChange={this.onMemberTagged}
                            id="post.comment"
                            className="form-control-sm lightgrey-bg"
                            placeholder="reply..."
                            maxLength={1000}
                            style={{width: "100%"}}
                            autoFocus={true}
                            tags={forum.members}
                            selectedTags={this.state.selectedTags}
                            >
                            </TextTagging>
                    <button type="submit" className="input-group-addon btn btn-default" id="btnGroupAddon">reply</button>
                </div> : undefined
                : postBox;

        return (<LocalForm model="post" 
                    onSubmit={this.onLocalSubmit.bind(this)} 
                    getDispatch={(dispatch) => this.formDispatch = dispatch}
                    validateOn="submit"
                    validators={{
                        '': {
                                comment: (vals) => { return vals.comment && vals.comment.length},
                            }
                    }}>                                              
                    {replyInput}
                </LocalForm>);
    }
}


// WEBPACK FOOTER //
// ./src/components/DiscussionBoard/Forum/AddReply.tsx